import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Button from 'components/Button/Button';
import Form from 'components/form';
import TextField from 'components/form/TextInput';
import { ConfigContext } from 'context/config';
import qs from 'qs';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { withTranslation } from 'react-i18next';
import { resetPassword } from 'services/users';
import createTheme from 'theme/makeTheme';
import toast from 'utils/toast';
import * as Styled from './styled';

const FormItem = Form.FormItem;

class ResetPassword extends React.Component {
  componentDidMount() {
    const { t } = this.props;
    const query = qs.parse(this.props.location.search.substr(1));
    if (!query.token) {
      toast.error(t('auth:missing-token-error', 'Invalid Request'));
      this.props.history.push('/login');
    } else {
      this.setState(query);
    }
  }

  handleSubmit = (e) => {
    const { t, form } = this.props;
    e.preventDefault();
    return form.validateFields().then((values) => {
      if (values.password !== values.confirmPassword) {
        toast.error(t('auth:password-do-not-match', 'Password do not match'));
      } else {
        return resetPassword(values.password, this.state.token).then(
          () => {
            toast.success(
              t(
                'auth:password-saved-success',
                'Your password is saved. You can now login',
              ),
            );
            this.props.history.push('/login');
          },
          (err) => toast.error(err.message),
        );
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      t,
    } = this.props;

    return (
      <ConfigContext.Consumer>
        {(config) => {
          const theme = createTheme(config.BRAND, 'dark');
          return (
            <ThemeProvider theme={theme}>
              <Styled.Container>
                <Helmet title="Set Password" />
                <Form>
                  <Styled.Wrapper>
                    <img
                      src={`/assets/images/${
                        config.BRAND === 'TMG'
                          ? 'tmg-logo-white.png'
                          : 'logo.svg'
                      }`}
                      alt="logo"
                      className="logo"
                    />
                    <Typography gutterBottom align="center" color="textPrimary">
                      {t(
                        'auth:new-password-message',
                        'Choose a new password to access your account. After saving, you will need to login using your email address and new password.',
                      )}
                    </Typography>
                    <div>
                      <FormItem>
                        {getFieldDecorator('password', {
                          rules: [
                            {
                              required: true,
                              message: t(
                                'auth:password-error',
                                'Please enter password',
                              ),
                            },
                          ],
                        })(
                          <TextField
                            placeholder={t(
                              'auth:password-placeholder',
                              'Enter Password',
                            )}
                            type="password"
                            fullWidth
                            margin="dense"
                          />,
                        )}
                      </FormItem>
                      <FormItem>
                        {getFieldDecorator('confirmPassword', {
                          rules: [
                            {
                              required: true,
                              message: t(
                                'auth:confirm-error',
                                'Please confirm password',
                              ),
                            },
                          ],
                        })(
                          <TextField
                            placeholder={t(
                              'auth:confirm-placeholder',
                              'Confirm Password',
                            )}
                            type="password"
                            fullWidth
                            margin="dense"
                          />,
                        )}
                      </FormItem>
                      <Box mt={1}>
                        <Button
                          fullWidth
                          onClick={this.handleSubmit}
                          variant="contained"
                          color="primary"
                          size="large"
                        >
                          {t('auth:save-password-button', 'Save New Password')}
                        </Button>
                      </Box>
                    </div>
                  </Styled.Wrapper>
                </Form>
              </Styled.Container>
            </ThemeProvider>
          );
        }}
      </ConfigContext.Consumer>
    );
  }
}

export default Form.create()(withTranslation('auth')(ResetPassword));
